import React from 'react'
// @ts-ignore
import { Table as NbTable } from '@netbasequid/core'
import { ColDef, CellProps, TableContext } from './types'
import { AutomationId } from '../../../utils/automationUtil'

/**
 *  resolve cell prop if the value has to be calculated dynamically
 * @param cellProps unresolved cellProps object
 * @param context data to passed to cell prop function
 */
const resolveCellProps = (
  cellProps: CellProps<any, any> | undefined,
  cellValue: any,
  context: TableContext<any, any>
): CellProps<any, any> => {
  const resovledCellProps: Record<string, any> = {}

  Object.entries(cellProps || {}).forEach(([key, value]) => {
    const resolvedValue = typeof value === 'function' ? value(cellValue, context) : value
    resovledCellProps[key] = resolvedValue
  })
  return resovledCellProps
}

const CellRenderer = ({
  colDef,
  context,
  indexOffset
}: {
  colDef: ColDef<any, any, any>
  context: TableContext<any, any>
  indexOffset: number
}): React.ReactElement => {
  const { field, customCellRender, children, cellProps } = colDef
  const { row } = context
  const cellValue = row[field]

  // renders multiple cells recursively
  if (children) {
    return (children.map((childColDef, index) => (
      <CellRenderer
        // eslint-disable-next-line react/no-array-index-key
        key={`${field as React.Key}${index}`}
        colDef={{ field, ...childColDef }}
        context={context}
        indexOffset={indexOffset + index}
      />
      // need to add type assertion since array iteration of jsx is not supported in typescript
      // https://github.com/typescript-cheatsheets/react/issues/57
    )) as any) as JSX.Element
  }

  return (
    <NbTable.TableCell
      testId={`${AutomationId.table.cell}-${indexOffset}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...resolveCellProps(cellProps, cellValue, context)}>
      {customCellRender?.(cellValue, context) || cellValue}
    </NbTable.TableCell>
  )
}

export default CellRenderer
